import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
import * as yup from "yup"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Gallery Picture Comments';
moduleConfig.singleItemTitle = 'Gallery Picture Comment';
moduleConfig.url = 'gallery-picture-comments';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Disabled Selected",
        value: "Disabled"
    },
    {
        displayName: "Enabled Selected",
        value: "Enabled"
    }
];


export default moduleConfig;